export default "__VITE_ASSET__w9nP0dB2__"